var checkListManager = (function () {
    var imageTextCardsCarousel;
    var indexCard = 0;
    var checkLists = $(".check-list-component");

    function init(){

        if ($(window).width() > 992 && (ENV.isEditmode==='' || ENV.isEditmode==='false') && checkLists.length>0){
            $(document).ready(function (){
                if(checkLists.length){
                    checkLists.each(function () {
                        resizeCardsHeight(this);
                    });
                }
            })
            $(window).resize(function(){
                if(checkLists.length){
                    checkLists.each(function () {
                        resizeCardsHeight(this);
                    });
                }
            })

            $(window).on('shown.bs.tab', function (e) {
                var activeTabCheckLists = $('.tab-pane.active.show .check-list-component', e.target.closest('section'));
                if (activeTabCheckLists.length>0){
                    resizeCardsHeight(activeTabCheckLists);
                }
            })
        }
    }

    function resizeCardsHeight(singleCheckListComponent){
        var selectedLayout = $(singleCheckListComponent).data('selected-layout');
        if('standard-layout'===selectedLayout){
            return;
        }
        var prefix = '.'+selectedLayout+' .prosConsBox';
        var elementsToResize = [' .pros-cons-title', ' .pros-cons-desc']
        elementsToResize.forEach(function (singleElement) {
            var singleElementMaxHeight = 0;
            $(singleCheckListComponent).find(prefix+singleElement).each(function () {
                var currentElement = $(this);
                currentElement.height('auto');
                singleElementMaxHeight = Math.max(singleElementMaxHeight, currentElement.height())
            });

            $(singleCheckListComponent).find(prefix+singleElement).height(singleElementMaxHeight);
        })
    }

    return {
        init: init
    }
})(jQuery);